import React from "react";
const Loader = () => {
    return (
        <>
            <div className="d-flex justify-content-center align-items-center flex-column vh-100">
                <img src="../images/loader.gif" className="" alt="Loader" />
            </div>
        </>
    );
};

export default Loader;
